import { InjectionToken } from '@angular/core';

export interface IRoblexCameraConfig {
    api: string;
}

export const CAMERA_VALUE_CONFIG: IRoblexCameraConfig = {
    api: '',
};

export const CAMERA_CONFIG = new InjectionToken<IRoblexCameraConfig>(
    'camera.config',
    {
        providedIn: 'root',
        factory: () => {
            return CAMERA_VALUE_CONFIG;
        },
    }
);
